<template>
  <div>
    <borFrame :title="'预警推送总览'" :iconShow="true" @iconClick="handleClick">
      <div class="borFrame_content" v-if="tabShow">
        <div class="borFrame_content_item" v-for="(item, index) in list" :key="index"
          :style="{ border: item.border, background: item.linear_gradient }">
          <div>
            {{ item.num }}
          </div>
          <div>
            {{ item.text }}
          </div>
        </div>
      </div>
      <div v-else>
        <TableDemo :columns="columns" :data="list"></TableDemo>
      </div>
      <p class="borFrame_content_more">
        {{ time }}共为您下发系统预警{{ list[0].num }}条，系统预警总量为{{ list[0].num }}条，较于昨日,系统预警{{ list[0].num -
          yesterdaySum > 0 ? '增加' + (list[0].num - yesterdaySum) : '增加0'
        }}条，其中敏感数量{{ list[1].num - yesterdayHarmful > 0 ? '增加' + (list[1].num - yesterdayHarmful) : '增加0' }}条。
      <div class="borFrame_content_more_btn" @click="detailsClick">
        查看详情 >
      </div>
      </p>
    </borFrame>
  </div>
</template>
<script>
import borFrame from "@/components/frame";
import TableDemo from "@/components/table";
import { warningStatistics } from '@/api/index'
import moment from 'moment';
export default {
  name: 'Push',
  components: {
    borFrame,
    TableDemo
  },
  data() {
    return {
      list: [
        { border: '1px solid #cbd9e5', linear_gradient: 'linear-gradient(to bottom, #cbd9e5, #fff)', num: 0, text: '当日预警总量' },
        { border: '1px solid #f9dedd', linear_gradient: 'linear-gradient(to bottom, #f9dedd, #fff)', num: 0, text: '当日敏感数量' },
        { border: '1px solid #f7f4e0', linear_gradient: 'linear-gradient(to bottom, #f7f4e0, #fff)', num: 0, text: '当日中性数量' },
        { border: '1px solid #d2e7ee', linear_gradient: 'linear-gradient(to bottom, #d2e7ee, #fff)', num: 0, text: '当日非敏感数量' },
      ],
      tabShow: true,
      columns: [
        {
          prop: 'text',
          label: '属性',
          width: '50%',
          align: 'center',
          'min-width': '0.6rem'
        },
        {
          prop: 'num',
          label: '预警数量',
          align: 'center',
          width: '50%',
          'min-width': '0.6rem'
        },
      ],
      time: '',
      yesterdayHarmful: 0,//	昨日敏感数量
      yesterdaySum: 0,//		昨日预警总量
    }
  },
  mounted() {
    this.time = this.$route.query.time;
    this.getList();
  },
  methods: {
    moment,
    handleClick() {
      this.tabShow = !this.tabShow
    },
    detailsClick() {
      this.$router.push({
        path: '/details',
        query: {
          time: this.$route.query.time
        }
      })
    },
    getList() {
      const time = this.$route.query.time;
      // time格式为2024年3月22日 将time格式化为2024-03-22
      const formatTime = moment(time, 'YYYY年M月D日').format('YYYY-MM-DD');
      //获取formatTime的开始时间和结束时间时间戳
      const startTime = moment(formatTime).startOf('day').valueOf();
      const endTime = moment(formatTime).endOf('day').valueOf();
      let data = {
        endTime: endTime,
        startTime: startTime,
        openId: localStorage.getItem('id')
      }
      warningStatistics(data).then((res) => {
        this.list[0].num = res.sum
        this.list[1].num = res.harmful
        this.list[2].num = res.neutral
        this.list[3].num = res.harmless
        this.yesterdayHarmful = res.yesterdayHarmful
        this.yesterdaySum = res.yesterdaySum
        this.$emit('updateList', res.sum, (res.sum - res.yesterdaySum))
      }).catch((err) => {
        console.log(err);
      });
    }
  }
}
</script>
<style lang="less" scoped>
.borFrame_content {
  /* 文字内容之间的间距 */
  letter-spacing: 1px;
  line-height: 1.5;
  display: flex;
  flex-wrap: wrap;

  &_item {
    width: 40%;
    margin: 1%;
    border-radius: 5px;
    text-align: center;
    font-size: .16rem;
    padding: .1rem;
  }


}

.borFrame_content_more {
  background: #f8f8f8;
  letter-spacing: 1px;
  line-height: 1.5;
  margin-top: .1rem;

  &_btn {
    margin-top: .1rem;
    color: #9a9494;
    font-size: .14rem;
    text-align: right;
  }
}
</style>